import * as React from 'react';

import { getTermValue } from '../../../../../JsonQuery';
import { Furniture } from '../../../components/advancedFilters/Furniture';
import { useContext } from '../../../utils/useContext';

export const FurnitureContainer: React.FC = () => {
  const { onChange, jsonQuery } = useContext();

  const value = getTermValue('with_furniture')(jsonQuery);

  const handleChange = React.useCallback(
    (withFurniture: boolean | null) => {
      onChange({ action: 'setWithFurniture', arguments: [withFurniture] });
    },
    [onChange],
  );

  return <Furniture value={value} onChange={handleChange} />;
};
